<template>
    <div class="recommend-similars-wrapper">
        <SimilarOptions
            :placeholder="placeholder"
            :allCheck="allCheckFlag"
            @deleteSimilar="deleteSimilar"
            @checkAllChange="checkAllChange"
            @searchSimilar="searchSimilar"
        >
            <OptionButton
                slot="customBtn"
                @menuClickHandler="menuClickHandler"
                popupDirect="down"
                :options="addOptions"
                :text="addBtn.text"
                :icon="addBtn.icon"
                :hoverIcon="addBtn.hoverIcon"
            ></OptionButton>
        </SimilarOptions>
        <SimilarList class="similar-list" :data="getSimilarData" @checkChange="itemCheckChange" unableEdit="true"></SimilarList>
        <div class="page-control">
            <PageControl
                :total="this.$store.state.zhiji.questionEdit.totalRecSimilars"
                :curPage="curPage"
                :lengthRank="pageLengthRank"
                :pageLength="pageLength"
                @pageChange="pageChange"
            />
            <div class="page-rank">
                <PageLengthSelect :pageRank="pageLengthRank" :curLength="pageLength" @lengthChange="lengthChange" />
            </div>
        </div>
    </div>
</template>

<script>
import PageControl from "@/views/zhiji/bComponents/pageController/PageControl";
import SimilarOptions from "./SimilarOptions";
import SimilarList from "./SimilarList";
import PageLengthSelect from "@/views/zhiji/bComponents/pageController/PageLengthSelect";
import OptionButton from "@/views/zhiji/bComponents/buttons/OptionButton";

import { STATIC_IMG_PATH } from "@/views/zhiji/js/common/constants.js";
import i18n from "@/i18n";

export default {
    name: "RecommendSimilars",
    props: ["questionId", "sceneId"],
    components: {
        SimilarOptions,
        SimilarList,
        PageLengthSelect,
        OptionButton,
        PageControl
    },
    data() {
        return {
            checkedRows: [],
            curPage: "1",
            pageLengthRank: ["10", "20", "30"],
            pageLength: "10",
            isShowQuestionModal: true
        };
    },
    computed: {
        allCheckFlag() {
            return this.checkedRows.length !== 0 && this.getSimilarData.length == this.checkedRows.length;
        },
        getSimilarData() {
            return this.convertListData(this.getStorePorp("recommendSimilarList"));
        },
        placeholder() {
            return this.$t("zhiji.knowlege.quesEditModal.searchRecomSimilar");
        },
        addOptions() {
            return [
                {
                    value: "currentQuestion",
                    label: this.$t("zhiji.knowlege.quesEditModal.currentQues")
                },
                {
                    value: "otherQuestion",
                    label: this.$t("zhiji.knowlege.quesEditModal.otherQues")
                }
            ];
        },
        addBtn() {
            return {
                text: this.$t("zhiji.knowlege.quesEditModal.addTo"),
                icon: "url(" + STATIC_IMG_PATH + "class-spr.png) no-repeat -297px 0px",
                hoverIcon: "url(" + STATIC_IMG_PATH + "class-spr.png) no-repeat -223px -99px"
            };
        }
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.zhiji.questionEdit[propName];
        },
        menuClickHandler(data) {
            data.value === "otherQuestion" ? this.addOtherQuestionClick() : this.addCurrentQuestionClick();
        },
        getCheckData() {
            let recObj = {
                recSimilars: [],
                recSimilarIds: [],
                recSimilarText: []
            };
            this.getSimilarData.map(similar => {
                return (
                    similar.checked &&
                    recObj.recSimilars.push({
                        questionId: similar.extQuestionId,
                        questionText: similar.extQuestion
                    }) &&
                    recObj.recSimilarIds.push(similar.extQuestionId) &&
                    recObj.recSimilarText.push(similar.extQuestion)
                );
            });
            return recObj;
        },
        addOtherQuestionClick() {
            if (this.checkedRowsTips()) {
                return;
            }
            let recommendSimilars = this.getCheckData().recSimilars;
            this.$store.dispatch("zhiji/showModal", {
                type: "LinkedQuestionModal",
                data: {
                    question: recommendSimilars,
                    title: i18n.t("zhiji.knowlege.quesEditModal.addTo") + i18n.t("zhiji.knowlege.quesEditModal.otherQues"),
                    confirm: data => {
                        if (0 in this.checkedRows) {
                            this.zhiji
                                .requestByServiceName("recSimilarLinkQuestion", {
                                    recSimilarIds: data.questionIdArray,
                                    recSimilars: data.questionArray,
                                    questionId: data.linkQuestionId
                                })
                                .then(() => {
                                    this.$store.dispatch("zhiji/searchRecommendSimilar", {
                                        questionId: this.questionId,
                                        page: this.curPage,
                                        size: this.pageLength
                                    });

                                    this.removeAllChecked();
                                    this.successTips(i18n.t("zhiji.knowlege.quesEditModal.addSuccess"));
                                });
                        }
                    }
                }
            });
        },
        checkedRowsTips() {
            if (this.checkedRows.length === 0) {
                this.$store.dispatch("zhiji/showModal", {
                    type: "MessageModal",
                    data: {
                        type: "tip",
                        message: i18n.t("zhiji.knowlege.quesEditModal.similarErrTip")
                    }
                });
                return true;
            }
        },
        addCurrentQuestionClick() {
            if (this.checkedRowsTips()) {
                return;
            }
            if (0 in this.checkedRows) {
                let recSimilarIds = this.getCheckData().recSimilarIds;
                let recSimilarText = this.getCheckData().recSimilarText;
                this.zhiji
                    .requestByServiceName("recSimilarLinkQuestion", {
                        recSimilarIds: recSimilarIds,
                        recSimilars: recSimilarText,
                        questionId: this.questionId
                    })
                    .then(() => {
                        this.$store.dispatch("zhiji/initQuesEditor", {
                            questionId: this.questionId,
                            sceneId: this.sceneId
                        });
                        this.successTips(i18n.t("zhiji.knowlege.quesEditModal.addSuccess"));
                    });
            }
        },
        successTips(tipText) {
            this.$store.dispatch("zhiji/showModal", {
                type: "MessageModal",
                data: {
                    type: "tip",
                    message: tipText,
                    cancel: () => {},
                    confirm: () => {}
                }
            });
        },
        deleteSimilar() {
            let configText = i18n.t("zhiji.knowlege.quesEditModal.deleteConfimTip1");
            this.checkedRows.length === 0
                ? (configText = i18n.t("zhiji.knowlege.quesEditModal.recomSimilarErrTip"))
                : this.checkedRows.length > 1
                ? (configText = i18n.t("zhiji.knowlege.quesEditModal.deleteConfimTip2"))
                : "";
            this.$store.dispatch("zhiji/showModal", {
                type: "MessageModal",
                data: {
                    type: "tip",
                    message: configText,
                    confirm: () => {
                        if (0 in this.checkedRows) {
                            let recSimilarIds = this.getCheckData().recSimilarIds;

                            this.zhiji
                                .requestByServiceName("deleteRecSimilars", {
                                    recSimilarIds: recSimilarIds.join(",")
                                })
                                .then(() => {
                                    this.$store.dispatch("zhiji/searchRecommendSimilar", {
                                        questionId: this.questionId,
                                        page: this.curPage,
                                        size: this.pageLength
                                    });

                                    this.removeAllChecked();
                                });
                        }
                    }
                }
            });
        },
        checkAllChange(data) {
            data.checked ? this.allPageChecked() : this.removeAllChecked();
        },
        removeAllChecked() {
            this.checkedRows.splice(0);
        },
        allPageChecked() {
            let similarList = this.getStorePorp("recommendSimilarList");

            similarList.forEach(similar => {
                this.itemCheckChange({
                    uId: similar.uId,
                    checked: true
                });
            });
        },
        searchSimilar(data) {
            this.$store.commit("zhiji/searchRecommendSimilarName", data);
        },
        itemCheckChange(data) {
            if (data.checked) {
                this.checkedRows.indexOf(data.uId) === -1 && this.checkedRows.push(data.uId);
            } else {
                let itemcheckedIdx = this.checkedRows.indexOf(data.uId);
                itemcheckedIdx !== -1 && this.checkedRows.splice(itemcheckedIdx, 1);
            }
        },
        pageChange(page) {
            if (this.curPageLen == page.pageLength && this.curPage == page.curPage) {
                return;
            }
            this.curPageLen = page.pageLength;
            this.curPage = page.curPage;

            this.$store.dispatch("zhiji/searchRecommendSimilar", {
                questionId: this.questionId,
                page: this.curPage,
                size: this.pageLength
            });

            this.removeAllChecked();
        },
        lengthChange(pageLen) {
            this.pageLength = pageLen;
        },
        convertListData(recSimilars) {
            return recSimilars.map(similar => {
                return {
                    checked: this.getCheckState(similar.uId),
                    uId: similar.uId,
                    extQuestion: similar.recSimilar,
                    extQuestionId: similar.recSimilarId,
                    questionId: similar.questionId,
                    sceneId: similar.sceneId
                };
            });
        },
        getCheckState(uId) {
            return this.checkedRows.some(rowUId => rowUId === uId);
        }
    }
};
</script>

<style lang="scss" scoped>
.recommend-similars-wrapper {
    display: flex;
    flex: 1;
    flex-direction: column;
    margin: 16px 0 16px 0;
    border: 1px solid #d8e4f0;
    border-radius: 4px;

    .similar-list {
        height: 489px;
    }
    .page-control {
        font-size: 12px;
        padding: 4px 0;
        border-top: 1px solid #d8e4f0;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        color: rgba(65, 71, 94, 0.7);
        background: #fafbfd;
        border-radius: 0 0 4px 4px;
        .page-rank {
            position: absolute;
            margin: 0 30px 0 0;
            right: 0px;
        }
    }

    .page-control:after {
        content: " ";
        clear: both;
        height: 0;
        visibility: hidden;
        display: block;
    }
}
</style>
